import React from "react";
import { Stepper, Step, StepButton, Box } from "@material-ui/core";
import ReserveFirstStep from "../../Homepage/pages/widgets/components/ReserveFirstStep";
import ReserveSecondStep from "../../Homepage/pages/widgets/components/ReserveSecondStep";
import ReserveThirdStep from "../../Homepage/pages/widgets/components/ReserveThirdStep";
// import ReserveFourthStep from "../../Homepage/pages/widgets/components/ReserveFourthStep";
import {
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import * as Scroll from "react-scroll";

const muiTheme = createMuiTheme({
  overrides: {
    MuiStepConnector: {
      root: {
        height: "3.3px",
        borderRadius: "5px",
        "&$active": {
          background: "#6dd06d",
        },
      },
    },
    MuiStepIcon: {
      root: {
        color: "darkgray", // or 'rgba(0, 0, 0, 1)'
        "&$active": {
          color: "#6dd06d",
        },
        "&$completed": {
          color: "#6dd06d",
        },
        fontSize: "35px",
        display: "block",
      },
      text: {
        fontFamily: "sans",
      },
    },
    MuiStepLabel: {
      root: {
        display: "block",
        color: "red", // or 'rgba(0, 0, 0, 1)'
        "&$active": {
          color: "green",
        },
        "&$completed": {
          color: "#6dd06d",
        },
      },
      iconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "5px",
      },
      label: {
        "&$active": {
          color: "#6dd06d",
          fontWeight: "bolder",
        },
        "&$completed": {
          color: "#6dd06d",
        },
      },
    },
  },
});

const steps = [
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>انتخاب</span> <span className="d-none d-md-inline">اتوبوس</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>مشخصات</span> <span className="d-none d-md-inline">مسافر</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>تایید</span> <span className="d-none d-md-inline">اطلاعات</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>پرداخت</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>صدور</span> <span className="d-none d-md-inline">بلیط</span>
  </h4>,
];

const SeatReserve = (props) => {
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: true });


  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);
  
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };


  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };



  const componentSituationSetter = (step) => {
    switch (+step) {
      case 1:
        return <ReserveFirstStep step={step} handleComplete={handleComplete} />;
      case 2:
        return <ReserveSecondStep step={step} handleComplete={handleComplete} />;
      case 3:
        return <ReserveThirdStep step={step} handleComplete={handleComplete} />;
      // case 3:
      //   return <ReserveThirdStep_old handleComplete={handleComplete} />;
      // case 4:
      //   return <ReserveFourthStep_old handleComplete={handleComplete} />;

      default:
        return <ReserveFirstStep step={step} handleComplete={handleComplete} />;
    }
  };

  const history = useHistory();
  const splittedURL = history.location.pathname.split("/");

  return (
    <>
      {" "}
      <div className="bg-white" style={{ borderTop: "1px solid #d9d9d9" }}>
        <Box className="container">
          <MuiThemeProvider theme={muiTheme}>
            <Stepper
              nonLinear
              style={{ overflow: "auto" }}
              activeStep={splittedURL[1] === "ticketdetails" ? 5 : activeStep}
            >
              {steps.map((label, index) => (
                <Step key={label} completed={completed[index]}>
                  <StepButton
                    color="white"
                    style={{ color: "white", display: "block" }}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          </MuiThemeProvider>
        </Box>
      </div>
      {componentSituationSetter(activeStep)}
    </>
  );
};

export default SeatReserve;
